export default __webpack_public_path__ + "static/media/black_friday_homepage_slide.e9138887.png";